export default __webpack_public_path__ + "static/media/reset-icon.b325f319.png";